<template>
  <section>
    <div class="my-3">
      <img src="/static/img/brand-visa.svg" height="32">&nbsp;
      <img src="/static/img/brand-master-card.svg" height="32">&nbsp;
      <img src="/static/img/brand-jcb.svg" height="32">&nbsp;
      <img src="/static/img/logo-opn-full.svg" height="28">
    </div>
    <div class="form-group">
      <label>{{ $t('message.booking.payment_step.card_number') }}</label>
      <cleave class="form-control input-jumbo"
              placeholder="•••• •••• •••• ••••"
              ref="number"
              v-model="paymentData.number"
              :options="{ creditCard: true }"/>
    </div>
    <div class="form-group">
      <label for="holderName">{{ $t('message.booking.payment_step.card_holder_name') }}</label>
      <input type="text"
             class="form-control input-jumbo"
             id="holderName"
             ref="holderName"
             v-model="paymentData.name">
    </div>
    <div class="row">
      <div class="col-md-7 col-7 p-0">
        <label>{{ $t('message.booking.payment_step.expire_date') }}</label>
        <cleave class="form-control input-jumbo"
                placeholder="MM/YY"
                ref="expirationDate"
                v-model="paymentData.expirationDate"
                :options="{ date: true, datePattern: ['m', 'y'] }"/>
      </div>
      <div class="col-md-5 col-5 no-padding-right-block">
        <div class="form-group">
          <label for="securityCode">{{ $t('message.booking.payment_step.security_code') }}</label>
          <input type="text"
                 class="form-control input-jumbo"
                 maxlength="3"
                 placeholder="•••"
                 size="3"
                 id="securityCode"
                 ref="securityCode"
                 v-model="paymentData.securityCode">
        </div>
      </div>
    </div>
    <!-- /.row -->

    <div class="d-flex mt-3">
      <div class="flex-fill">
        {{ $t('message.payment_method.set_default_card') }}
      </div>
      <div>
        <toggle-button v-model="isDefault"
                       :sync="true"
                       color="#FFC107" />
      </div>
    </div>

    <div class="mt-3">
      <span class="text-order-title">
        {{ $t('message.booking.payment_step.payment_test_remark') }}
      </span>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Cleave from 'vue-cleave'

  export default {
    props: {
      paymentData: Object
    },
    components: {
      Cleave
    },
    data () {
      return {
        isDefault: false
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    watch: {
      isDefault () {
        this.paymentData.isDefault = (this.isDefault) ? 1 : 0
      }
    },
    methods: {
      getCardType (number) {
        number = number.replace(/\s+/g, '')
        let result = ''
        // visa
        let re = new RegExp('^4')
        if (number.match(re)) {
          result = 'Visa'
        }
        // Mastercard
        re = new RegExp('^5[1-5]')
        if (number.match(re)) {
          result = 'Mastercard'
        }
        // JCB
        re = new RegExp('^35(2[89]|[3-8][0-9])')
        if (number.match(re)) {
          result = 'JCB'
        }
        return result
      },
      scrollTo (offsetTop) {
        window.scrollTo(0, offsetTop - 100)
      },
      paymentFormValidation () {
        if (!this.paymentData.number) {
          this.$refs.number.$el.focus()
          this.scrollTo(this.$refs.number.$el.offsetTop)
          return false
        } else if (!this.getCardType(this.paymentData.number)) {
          this.$refs.number.$el.value = ''
          this.$refs.number.$el.focus()
          this.scrollTo(this.$refs.number.$el.offsetTop)
          return false
        } else if (!this.paymentData.name) {
          this.$refs.holderName.focus()
          this.scrollTo(this.$refs.holderName.offsetTop)
          return false
        } else if (!this.paymentData.expirationDate) {
          this.$refs.expirationDate.$el.focus()
          this.scrollTo(this.$refs.holderName.offsetTop)
          return false
        } else if (!this.paymentData.securityCode) {
          this.$refs.securityCode.focus()
          this.scrollTo(this.$refs.holderName.offsetTop)
          return false
        } else {
          return true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/payment/PaymentForm.vue